import React from 'react';
import { getStatus } from '../config';

const SIZES = {
  sm: 'text-[11px] px-2 py-[2px]',
  md: 'text-xs px-2.5 py-1',
};

const StatusPill = ({ status, size = 'sm', className = '' }) => {
  const meta = getStatus(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-medium ring-1 ring-inset ${meta.pill} ${SIZES[size] || SIZES.sm} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
};

export default StatusPill;
